import { Component, OnInit } from '@angular/core';
import { MemberService } from '@app/services/member.service';
import { CSVDataService } from '@app/export/CSVDataService';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { DatePipe } from '@angular/common';

interface SOFTSubscribers {
  country: string;
  zipcode: string;
  name: string;
  careof: string;
  street: string;
  city: string;
  member: number;
}

@Component({
  selector: 'app-softsubscribers',
  templateUrl: './softsubscribers.component.html',
  styleUrls: ['./softsubscribers.component.css']
})
export class SoftsubscribersComponent implements OnInit {
  softsubscribers: SOFTSubscribers[] = [];
  working = false;

  constructor(
    private memberService: MemberService,
    private snackbarService: SnackbarService,
    private datePipe: DatePipe) {

  }

  ngOnInit() {
    this.memberService.timestamp.subscribe(response => {
      if (response) {
        this.getSOFTData();
      }
    });
  }

  getSOFTData() {
    this.working = true;
    this.memberService.getSOFTSubscribers().subscribe(data => {
      if (data) {
        this.softsubscribers = data;
        this.exportToCSV();
        this.snackbarService.openSnackBar('Generering av Excelfil slutförd. Antal poster: ' + this.softsubscribers.length, null);
        this.working = false;
      }
    });
  }
  exportToCSV() {
    const firstrow = 'Name of company;Adress 1;Adress 2;ZIP Code;City;ISO Country;Description 1';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'SOFTprenumeranter_' + datum;
    CSVDataService.exportToCsv(filnamn + '.csv', this.softsubscribers, firstrow);
  }
}
